var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-inline p-0"},[_c('b-badge',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:'information-badge '.concat(' ', _vm.badgeClass),attrs:{"pill":"","variant":_vm.variant,"title":_vm.message}},[_c('i',{class:'fa '.concat(_vm.faIconClass)})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }